export default __webpack_public_path__ + "static/media/mask.2a9a7a9f.jpg";